<template>
  <div class="login">
    <div class="login__main">
      <div class="login__header">
        <div class="container">
          <div class="login__header-wrapper">
            <img src="@images/logo.png" alt="logo">
          </div>
        </div>
      </div>
      <div class="container">
        <div class="login__wrapper">
          <form @submit.prevent="send" class="login__form">
            <h1 class="login__title">LOG IN</h1>
            <div class="login__block">
              <p>Email</p>
              <ui-input
                  :type="'email'"
                  :placeholder="'Email'"
                  :rules="[isEmail]"
                  v-model="email"
              />
            </div>
            <div class="login__block">
              <p>Password</p>
              <ui-input
                  :type="'password'"
                  :placeholder="'Password'"
                  v-model="password"
              />
            </div>
            <ui-checkbox class="login__checkbox">
              Remember Me
            </ui-checkbox>
            <button type="submit" class="login__button">Sing In</button>
          </form>
        </div>
      </div>
    </div>
    <img class="login__image" src="@images/bottomBg.png" alt="image">
  </div>
</template>

<script setup>
import UiInput from "@/components/ui/ui-input.vue";
import {isEmail} from "@/core/rules/textFieldRules.js";
import {ref} from "vue";
import UiCheckbox from "@/components/ui/ui-checkbox.vue";
import {ElNotification} from "element-plus";

const email = ref('')
const password = ref('')

const send = () => {
  ElNotification({
    message: 'This account does not exist.',
    type: 'error'
  })
}
</script>

<style lang="scss" scoped>
.login {
  background-color: #272727;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 50px;

  &__header {
    padding-block: 30px;
  }

  &__form {
    margin-top: 25px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 15px;
    width: 400px;
    margin-inline: auto;
  }

  &__title {
    background-image: url(@images/titleBg.png);
    background-repeat: no-repeat;
    -webkit-background-clip: text;
    background-size: cover;

    color: transparent;
    font-size: 118px;
    font-weight: 700;
  }

  &__block {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 10px;

    & p {
      color: $white;
      font-size: 16px;
    }
  }

  &__checkbox {
    align-self: flex-start;
  }

  &__button {
    margin-top: 20px;
    cursor: pointer;
    background-color: #FFBE5A;
    padding: 15px 80px;
    transition: 0.2s;

    color: $black;
    text-align: center;
    font-family: Poppins, sans-serif;
    font-size: 16px;

    @include hover {
      background-color: #fdc884;
    }
  }

  &__image {
    width: 100%;
  }
}

@media (max-width: 1000px) {
  .login {
    &__title {
      font-size: 86px;
    }

    &__block {
      & p {
        font-size: 18px;
      }
    }

    &__button {
      padding-block: 10px;
      font-size: 18px;
    }
  }
}

@media (max-width: 450px) {
  .login {
    &__form {
      width: 100%;
    }
  }
}
</style>